import AIEntityInstruction from 'models/aiEntityInstruction';

export class CopilotExternalDocumentInstructionEditRequest {
  externalId: string;

  constructor() {
    this.externalId = '';
  }
}

export class CopilotExternalDocumentInstructionEdit {
  externalId: string;

  libraryLinkId: number;

  libraryListId: number;

  title?: string;

  pendingInstruction: string;

  instruction?: AIEntityInstruction;

  constructor() {
    this.externalId = '';
    this.libraryLinkId = 0;
    this.libraryListId = 0;
    this.pendingInstruction = '';
  }
}
